module.exports = __webpack_public_path__ + "static/media/zm.f49ae22d.svg";